import React, { Component } from 'react'
import NumberAnimation from './NumberAnimation'

export class Card1 extends Component {
    render() {
        const { number, title } = this.props;

        return (
            <div className={`flex items-center gap-[16px] ${this.props.className} `}>

                <NumberAnimation targetNumber={number} />

                <div>
                    <h2 className='font-[700] text-[20px] text-[#000] max-[750px]:text-[18px] max-[390px]:text-[16px] max-[390px]:font-[500]'>{title}</h2>
                    {/* <p className='text-[#676879] font-[400] text-[15px]'> 3 texniki destek </p> */}
                </div>
            </div>
        )
    }
}

export default Card1